import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchNutritionLabel } from "../../../../../shared/hooks/useFetchServiceDetails";
import API_URLS from "../../../Utils/axr";
import store from "../../store";
import DwLogutil from "../../../Utils/DwLogutil";
import { EC_DW_LOGGING_STEPS } from "../../../../../shared/utils/Constants";
import PlanDetails from "../../../Pages/accountSetting/planDetails";
import { PURGE } from "redux-persist";

type nutritionLabelInitialStateType = {
  offerResponse: any;
  loading: boolean;
  error: any;
};
const initialState: nutritionLabelInitialStateType = {
  offerResponse: null,
  loading: false,
  error: null,
};

export const getNutritionLabelContent = createAsyncThunk(
  "product/nutritionLabel",
  async (productId?: string) => {
    try {      
      const productCode = productId ?? "";
      const reduxStore = store.getState();
      const billingType = reduxStore?.brightSpeedUserUtils?.accountType;
      const headers = reduxStore?.brightspeedToken?.headers;
      const { sessionId } = reduxStore?.user;
      const servicePlan: any = reduxStore?.planDetails?.planDetails ;
      const wireCenter =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.wireCenter;
      const mmmCode =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.marketingProfile?.mmmCode;
      const uploadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxUpBandwidth;
      const downloadSpeed =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.qualificationDetails?.maxDownBandwidth;
      const partnerSessionId =
        reduxStore?.addressQualification?.data?.addressQualification?.entity
          ?.partnerSessionId;
      const isSupplementOrderEnabled = reduxStore?.brightSpeedUserUtils?.isSupplementOrderEligible;

  let productRatePlanId = "";
      let productRatePlanIdCTLUser ="";
      const instantInternet = reduxStore.addressQualification?.data?.addressQualification?.entity?.instantInternet
      if (servicePlan?.standardPlans?.length > 0) {
        for (
          let index = 0;
          index < servicePlan?.standardPlans?.length;
          index++
        ) {
          const element = servicePlan?.standardPlans[index];
          if (element?.productName?.toLowerCase()?.includes("internet")) {
            if (((headers?.siteId?.toLowerCase() === "bs" && billingType?.toLowerCase() === "postpaid") || (headers?.siteId?.toLowerCase() === "qf" && billingType?.toLowerCase() === "postpaid"))
              && (element?.productType?.toLowerCase().includes("fi") && !(element?.productType?.toLowerCase().includes("fv")))) {
              productRatePlanId = element?.productRatePlanId;
            }
            else if ((headers?.siteId?.toLowerCase() === "bs" && billingType?.toLowerCase() === "prepaid") || (headers?.siteId?.toLowerCase() === "qf" && billingType?.toLowerCase() === "prepaid")
              || (headers?.siteId?.toLowerCase() === "qf-ii" || instantInternet === true)) {
              productRatePlanId = element?.productRatePlanId;
            }
          }
          if (element?.productIdDescription?.toLowerCase()?.includes("internet") || (element?.productName.toLowerCase()?.includes("internet"))) {
            productRatePlanIdCTLUser = element?.productRatePlanId;
          }
        }
      }
      else {
        if(productId){
           productRatePlanId = productCode;
        }         
      }
  
      const payload = {
        baseline: {
          transactionId: partnerSessionId || "",
          partnerId: "",
          salesCode: "",
          referenceId: "",
          orderId: "",
          agentId: "",
          channel: "acm",
          siteId: headers?.siteId
            ? ["qf", "qf-ii", "quantum fiber"]?.includes(
                headers?.siteId?.toLowerCase()
              )
              ? "qf"
              : headers?.siteId?.toLowerCase()
            : "",
          wirecenter: wireCenter || "",
        },
        productId: ((headers?.siteId?.toLowerCase() ==="bs" && billingType?.toLowerCase() === "postpaid" || headers?.siteId?.toLowerCase() === "qf" && billingType?.toLowerCase() === "postpaid")&& !isSupplementOrderEnabled) ? `GOF_${productRatePlanId}` : productRatePlanId || "",
        wireCenter: wireCenter || "",
        mmmCode: mmmCode || "",
        uploadSpeed: uploadSpeed || "",
        downloadSpeed: downloadSpeed || "",
      };
      const payloadCTLUser = {
        baseline: {
          transactionId: `copper-${sessionId}` || `copper-${headers?.sessionId}` ||  "",
          partnerId: "",
          salesCode: "",
          agentId: "",
          channel: "acm",
          siteId: headers?.siteId
            ? ["qf", "qf-ii", "quantum fiber"]?.includes(
                headers?.siteId?.toLowerCase()
              )
              ? "qf"
              : headers?.siteId?.toLowerCase()
            : "",
          wirecenter: wireCenter || "",
          intent : ""
        },
        productId: `GOF_${productRatePlanIdCTLUser}` || "",
        wireCenter: wireCenter || "",
      };
      let url=API_URLS?.nutritionlabel;
      const params = {
        "": url ,
      };
      const response = await fetchNutritionLabel(params, headers?.siteId ==="ctl" ? payloadCTLUser : payload, headers);
      if(response?.data?.offerResponse?.offerDetails?.billingRateProductId) {
        DwLogutil({stepName: EC_DW_LOGGING_STEPS?.nutritionLabel_success})
      } else {
        DwLogutil({stepName: EC_DW_LOGGING_STEPS?.nutritionLabel_failed, error: "Response data is empty"})
      }
      return response.data;
    } catch (error) {
      DwLogutil({stepName: EC_DW_LOGGING_STEPS?.nutritionLabel_failed, error: "somthing went wrong while fetching the API details"})
      throw error;
    }
  }
);

const nutritionLabelSlice = createSlice({
  name: "product/nutritionLabel",
  initialState,
  reducers: {
    clearNutritionLabelSlice: (state) => {
      return initialState;
    },
    nutritionLabelSliceSetInitialState: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getNutritionLabelContent.pending, (state) => {
      state.loading = true;
      state.offerResponse = null;
    });
    builder.addCase(getNutritionLabelContent.fulfilled, (state, action) => {
      state.offerResponse = action.payload;
      state.loading = false;
      state.error = null;
    });
    builder.addCase(getNutritionLabelContent.rejected, (state, action) => {
      state.offerResponse = null;
      state.loading = false;
      state.error = action.error;
    });
    builder.addCase(PURGE, () => {
      return initialState;
    })
  },
});

export default nutritionLabelSlice.reducer;
